// extracted by mini-css-extract-plugin
module.exports = {"card":"icon-card-module--card--3YFDH","header":"icon-card-module--header--30GRO","footer":"icon-card-module--footer--lQpR5"};